import BaseService from "./BaseService";

export class VersionService extends BaseService {
	constructor() {
		super('/Version');
	}
}
